import React, { memo }  from 'react';

const IconWrapper = (props) => {

    return (
        <svg fill={props.fill ? props.fill : "none"} className={`icon icon-${props.className}`} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox={props.viewBox} style={{enableBackground: `new ${props.viewBox}`, fill: props.fill ? props.fill : "none"}}>
            {props.children}
        </svg>
    );
}

export default IconWrapper;
